import { axiosGetHandler, axiosPostHandler } from './config';
import { extractAPIValues } from '_lib/utils/utils';
const { BASE_XHH } = extractAPIValues();

// 创建群聊
export function createGroupChat(args, formData) {
  const url = BASE_XHH + '/chat_group/create';
  return axiosPostHandler(url, args, formData);
}

// 获取群聊详情
export function getGroupChatDetail(args) {
  const url = BASE_XHH + '/chat_group/detail';
  return axiosGetHandler(url, args);
}

// 获取群聊基础信息
export function getGroupChatBaseInfo(args) {
  const url = BASE_XHH + '/chat_group/info';
  return axiosGetHandler(url, args);
}

// 获取群聊列表
export function getGroupChatList(args) {
  const url = BASE_XHH + '/chat_group/my_list';
  return axiosGetHandler(url, args);
}

// 获取群聊成员详情
export function deleteGroupChat(args, formData) {
  const url = BASE_XHH + '/chat_group/delete';
  return axiosPostHandler(url, args, formData);
}

// 展示群聊
export function showGroupChat(args, formData) {
  const url = BASE_XHH + '/chat_group/show';
  return axiosPostHandler(url, args, formData);
}

// 更新群聊基本信息
export function updateGroupChatInfo(args, formData) {
  const url = BASE_XHH + '/chat_group/info/update';
  return axiosPostHandler(url, args, formData);
}

// 群聊用户列表
export function getGroupChatMemberList(args) {
  const url = BASE_XHH + '/chat_group/user/list';
  return axiosGetHandler(url, args);
}

// 更新通知设置
export function updateGroupChatNotify(args, formData) {
  const url = BASE_XHH + '/chat_group/user/notify/update';
  return axiosPostHandler(url, args, formData);
}

// 更新群聊用户备注
export function updateGroupChatMemberRemark(args, formData) {
  const url = BASE_XHH + '/chat_group/user/nickname/update';
  return axiosPostHandler(url, args, formData);
}

// 退出群聊
export function exitGroupChat(args, formData) {
  const url = BASE_XHH + '/chat_group/user/leave';
  return axiosPostHandler(url, args, formData);
}

// 解散群聊
export function dismissGroupChat(args, formData) {
  const url = BASE_XHH + '/chat_group/delete';
  return axiosPostHandler(url, args, formData);
}

// 获取群聊消息列表
export function getGroupMessageList(args) {
  const url = BASE_XHH + '/chatroom/v2/chat_group_msg/list';
  return axiosGetHandler(url, args);
}

// 更新消息已读状态
export function updateMessageRead(args, formData) {
  const url = BASE_XHH + '/chatroom/v2/msg/read';
  return axiosPostHandler(url, args, formData);
}

// 获取消息列表
export function getMessageListByPage(args) {
  const url = BASE_XHH + '/chatroom/v2/msg/group/page';
  return axiosGetHandler(url, args);
}

// 获取群聊邀请码
export function getGroupChatInviteCode(args) {
  const url = BASE_XHH + '/chat_group/invite_code';
  return axiosGetHandler(url, args);
}

// 获取群聊邀请码信息
export function getGroupChatInviteCodeInfo(args) {
  const url = BASE_XHH + '/chat_group/invite_code/info';
  return axiosGetHandler(url, args);
}

// 踢出群成员
export function removeGroupChatMember(args, formData) {
  const url = BASE_XHH + '/chat_group/user/kick_out';
  return axiosPostHandler(url, args, formData);
}

// 获取管理员列表
export function getGroupChatAdminList(args) {
  const url = BASE_XHH + '/chat_group/manager/list';
  return axiosGetHandler(url, args);
}

// 设置管理员
export function updateGroupChatManager(args, formData) {
  const url = BASE_XHH + '/chat_group/manager/update';
  return axiosPostHandler(url, args, formData);
}

// 获取群聊黑名单列表
export function getGroupChatBlockUserList(args) {
  const url = BASE_XHH + '/chat_group/black_list';
  return axiosGetHandler(url, args);
}

// 添加群聊黑名单
export function updateGroupChatBlockUser(args, formData) {
  const url = BASE_XHH + '/chat_group/black_list/update';
  return axiosPostHandler(url, args, formData);
}

// 发送修改消息
export function sendGroupChatMessage(args, formData) {
  const url = BASE_XHH + '/chatroom/v2/chat_group_msg/send';
  return axiosPostHandler(url, args, formData);
}

// 删除群聊消息
export function deleteGroupChatMessage(args, formData) {
  const url = BASE_XHH + '/chatroom/v2/chat_group_msg/delete';
  return axiosPostHandler(url, args, formData);
}

// 删除群公告
export function deleteGroupChatAnnouncement(args, formData) {
  const url = BASE_XHH + '/msg/chat_group/anc/delete';
  return axiosPostHandler(url, args, formData);
}

// 删除群公告置顶
export function deleteGroupChatAnnouncementTop(args, formData) {
  const url = BASE_XHH + '/msg/chat_group/anc/un_top';
  return axiosPostHandler(url, args, formData);
}

// 置顶群消息
export function topGroupChatMessage(args, formData) {
  const url = BASE_XHH + '/msg/chat_group/set_top';
  return axiosPostHandler(url, args, formData);
}

// 获取消息Emoji回复的用户列表
export function getGroupChatMessageEmojiReplyUserList(args) {
  const url = BASE_XHH + '/chatroom/v2/chat_group_msg/emoji/users';
  return axiosGetHandler(url, args);
}

// 回复Emoji
export function replyGroupChatMessageEmoji(args, formData) {
  const url = BASE_XHH + '/chatroom/v2/chat_group_msg/emoji/reply';
  return axiosPostHandler(url, args, formData);
}

// 获取群聊邀请码二维码
export function getChatGroupInviteQrCode(args) {
  const url = BASE_XHH + '/chat_group/invite_code/pc_qr';
  return axiosGetHandler(url, args);
}

// 清除群聊消息未读状态
export function updateChatGroupMsgReadState(args, formData) {
  const url = BASE_XHH + '/chatroom/v2/chat_group_msg/clear_read_states';
  return axiosPostHandler(url, args, formData);
}

// 编辑群聊消息（同发送消息接口）
export function editGroupChatMessage(args, formData) {
  const url = BASE_XHH + '/chatroom/v2/chat_group_msg/send';
  return axiosPostHandler(url, args, formData);
}

// 根据特定im_seq获取群聊消息列表
export function spotGroupChatMessage(args) {
  const url = BASE_XHH + '/chatroom/v2/chat_group_msg/spot';
  return axiosGetHandler(url, args);
}

// 获取已读
export function getGroupChatReadState(args) {
  const url = BASE_XHH + '/chatroom/v2/chat_group_msg/read_states';
  return axiosGetHandler(url, args);
}

// 从消息列表里面移出群聊
export function completeChatGroupMsg(args, formData) {
  const url = BASE_XHH + '/chat_group/message/list/delete';
  return axiosPostHandler(url, args, formData);
}

// 修改置顶状态
// TODO 修改接口路径
export function updateGroupChatTopChat(args, formData) {
  const url = BASE_XHH + '/chat_group/top_chat/update';
  // return axiosPostHandler(url, args, formData);
  return new Promise((resolve) => {
    resolve({
      data: {
        status: 'ok',
      },
    });
  });
}

/**
 * 获取群聊加入设置
 * @param {*} args
 * @param {*} formData
 */
export function getGroupChatJoinSettings(args) {
  const url = BASE_XHH + '/chat_group/join_setting/info';
  return axiosGetHandler(url, args);
}

/**
 * 更新群聊加入设置通知
 * @param {*} args
 * @param {*} formData
 * @returns
 */
export function updateGroupChatJoinCondition(args, formData) {
  const url = BASE_XHH + '/chat_group/join_setting/condition/update';
  return axiosPostHandler(url, args, formData);
}

/**
 * 更新群聊加入设置审批开关
 * @param {*} args
 * @param {*} formData
 * @returns
 */
export function updateGroupChatJoinApprovalSwitch(args, formData) {
  const url = BASE_XHH + '/chat_group/join_setting/approval/toggle';
  return axiosPostHandler(url, args, formData);
}

/**
 * 入群申请通知开关
 * @param {*} args
 * @param {*} formData
 * @returns
 */
export function updateGroupChatJoinNotifySwitch(args, formData) {
  const url = BASE_XHH + '/chat_group/join_setting/approval/update_notify';
  return axiosPostHandler(url, args, formData);
}

/**
 * 获取入群申请列表
 * @param {*} args
 * @returns
 */
export function getGroupChatJoinApprovalList(args) {
  const url = BASE_XHH + '/chat_group/join_setting/approval/list';
  return axiosGetHandler(url, args);
}

/**
 * 获取入群申请历史
 * @param {*} args
 * @returns
 */
export function getGroupChatJoinApprovalHistoryList(args) {
  const url = BASE_XHH + '/chat_group/join_setting/approval/history_list';
  return axiosGetHandler(url, args);
}

/**
 * 更新入群申请状态
 * @param {*} args
 * @param {*} formData
 * @returns
 */
export function updateGroupChatJoinApprovalState(args, formData) {
  const url = BASE_XHH + '/chat_group/join_setting/approval/handle';
  return axiosPostHandler(url, args, formData);
}

/**
 * 检查是否已经加入群聊
 * @param {*} args
 * @returns
 */
export function getCheckJoinedGroupChat(args) {
  const url = BASE_XHH + '/chat_group/join/pre_check';
  return axiosGetHandler(url, args);
}
